import React, { Component, Fragment } from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Redirect, Link } from 'react-router-dom';

import Content from './Content';
import PositionCard from './PositionCard';
import StyleUtils from './StyleUtils';

class PositionPage extends Component {
  constructor(props) {
    super(props);
    this.getContent = this.getContent.bind(this);
    this.state = {
      ...this.getContent(),
    };
  }

  componentDidMount() {
    if (!this.state.sectionInfo) {
      return;
    }

    document.title = (this.state.positionInfo)
      ? `Join TMD | ${this.state.sectionInfo.name} | ${this.state.positionInfo.name}`
      : `Join TMD | ${this.state.sectionInfo.name}`;
    this.setState({
      ...this.getContent(),
    });
    window.scrollTo(0, 0);
  }

  componentDidUpdate(oldProps) {
    if (oldProps.section !== this.props.section || oldProps.position !== this.props.position) {
      this.setState({
        ...this.getContent(),
      });
      window.scrollTo(0, 0);
    }
  }

  getContent() {
    // If not familiar, "[foo] = array" notation sets foo to the value at index 0
    const [sectionInfo] = Content.sections.filter(section => section.route === this.props.section);
    if (!sectionInfo) {
      return {};
    }
    const [positionInfo] = sectionInfo.positions.filter(p => p.route === this.props.position);
    return {
      sectionInfo,
      positionInfo,
    };
  }

  renderTopImage() {
    const boldStyle = {
      fontWeight: 400,
    };

    return (
      <div className={css(styles.topImage)}>
        <div className={css(styles.topShade)}>
          <div className={css(styles.topInfo)}>
            <h2 className={css(styles.topHeader)}>
              <span style={boldStyle}>
                {this.state.sectionInfo.name}
              </span>
              <br />
              {' '}
              {this.state.positionInfo && this.state.positionInfo.name}
            </h2>
          </div>
        </div>
      </div>
    );
  }

  renderSectionNav() {
    const sections = Content.sections.map(section => (
      <Link to={`/${section.route}`} className={css(styles.sectionNavLink)}>
        {section.name}
      </Link>
    ));
    return (
      <div className={css(styles.sectionNavBar)}>
        {sections}
      </div>
    );
  }

  renderSection() {
    return (
      <Fragment>
        {this.renderSectionDescription()}
        <div className={css(styles.lineBox)} />
        {this.renderAllPositionCards()}
      </Fragment>
    );
  }

  renderPosition() {
    return (
      <Fragment>
        {this.renderPositionDescription()}
        <div className={css(styles.lineBox)} />
        {this.renderSectionDescription()}
        {this.renderOtherPositionCards()}
      </Fragment>
    );
  }

  renderSectionDescription() {
    return (
      <Fragment>
        <h1 className={css(styles.positionTitle)}>
          {this.state.sectionInfo.name}
        </h1>
        <div
          dangerouslySetInnerHTML={{ __html: this.state.sectionInfo.description }}
          className={css(styles.description)}
        />
      </Fragment>
    );
  }

  renderPositionDescription() {
    return (
      <Fragment>
        <h1 className={css(styles.positionTitle)}>
          {this.state.positionInfo.name}
        </h1>
        <div
          dangerouslySetInnerHTML={{ __html: this.state.positionInfo.description }}
          className={css(styles.description)}
        />
        {this.state.positionInfo.requirements
          && (
          <Fragment>
            <strong className={css(styles.requirementsTitle)}>
              {'Requirements'}
            </strong>
            <ul>
              {this.state.positionInfo.requirements.map(req => (
                <li className={css(styles.requirementText)}>
                  {req}
                </li>
              ))}
            </ul>
          </Fragment>
          )}
        <a href={this.state.positionInfo.ctaLink} className={css(styles.applyButton)}>
          <h3 className={css(styles.applyButtonText)}>
            {this.state.positionInfo.ctaLabel || 'Apply'}
          </h3>
        </a>
      </Fragment>
    );
  }

  renderAllPositionCards() {
    return (
      <Fragment>
        <h2 className={css(styles.positionTitle)}>
          {'Positions'}
        </h2>
        {this.state.sectionInfo.positions.map(position => (
          <PositionCard positionContent={position} sectionContent={this.state.sectionInfo} />
        ))}
      </Fragment>
    );
  }

  renderOtherPositionCards() {
    if (this.state.sectionInfo.positions.length === 1) {
      return null;
    }

    const otherPositions = this.state.sectionInfo.positions.filter(
      position => (this.state.positionInfo.name !== position.name),
    );

    return (
      <Fragment>
        <h2 className={css(styles.positionTitle)}>
          {'Other Positions'}
        </h2>
        {otherPositions.map(position => (
          <PositionCard positionContent={position} sectionContent={this.state.sectionInfo} />
        ))}
      </Fragment>
    );
  }

  render() {
    if (!this.state.sectionInfo) {
      return <Redirect to="/" />;
    }

    // if (!this.state.positionInfo && this.props.position) {
    //   return <Redirect to={`/${this.props.section}`} />;
    // }

    // const backRoute = `/${this.state.sectionInfo.route}`;

    return (
      <Fragment>
        {this.renderTopImage()}
        {/* this.renderSectionNav() */}
        <div className={css(styles.pageContent)}>
          {/* this.state.positionInfo && (
          <div className={css(styles.backHolder)}>
            <img src="/IMG/back.png" className={css(styles.backIMG)} />
            <a href={backRoute} className={css(styles.backRoute)}>
              {this.state.sectionInfo.name}
            </a>
          </div>
          ) */}
          {this.state.positionInfo
            ? this.renderPosition()
            : this.renderSection()}
        </div>
      </Fragment>
    );
  }
}

const styles = StyleSheet.create({
  topImage: {
    backgroundImage: "url('/tmd_recruit/IMG/newsroom.jpg')",
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: 300,
    position: 'relative',
    transition: StyleUtils.fastTransition,
    '@media (max-width: 535px)': {
      height: 200,
    },
  },
  topShade: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(55,69,103,0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  topInfo: {
    color: 'white',
    textAlign: 'center',
  },
  topHeader: {
    fontFamily: 'Helvetica Neue, Helvetica, Open Sans, sans-serif',
    fontWeight: 300,
    fontSize: 48,
    '@media (max-width: 535px)': {
      fontSize: 36,
    },
  },
  pageContent: {
    maxWidth: 1024,
    margin: 'auto',
    padding: 20,
  },
  backHolder: {
    display: 'flex',
    alignItems: 'center',
  },
  backIMG: {
    width: 20,
    marginRight: 5,
  },
  backRoute: {
    textDecoration: 'none',
    color: '#198BF1',
    fontFamily: 'Helvetica Neue, Helvetica, Open Sans, sans-serif',
    fontSize: 18,
    fontWeight: 400,
  },
  description: {
    fontFamily: 'Times New Roman, Times, serif',
    fontSize: 20,
    textDecoration: 'none',
    margin: '0px 0px 20px 0px',
    '@media (max-width: 535px)': {
      fontSize: 18,
    },
  },
  lineBox: {
    width: '100%',
    height: 1,
    borderRadius: 3,
    marginTop: 20,
    backgroundColor: '#374567',
    display: 'inline-block',
  },
  positionTitle: {
    fontFamily: 'Helvetica Neue, Helvetica, Open Sans, sans-serif',
    fontWeight: 500,
    fontSize: 24,
  },
  requirementsTitle: {
    fontFamily: 'Helvetica Neue, Helvetica, Open Sans, sans-serif',
    fontWeight: 500,
    fontSize: 16,
  },
  requirementText: {
    fontFamily: 'Times New Roman, Times, serif',
    fontWeight: 400,
    fontSize: 16,
  },
  applyButton: {
    width: 'auto',
    height: 'auto',
    padding: '10px 35px',
    marginLeft: 'calc(50% - 60px)',
    backgroundColor: StyleUtils.buttonBlue,
    color: 'white',
    borderRadius: 3,
    float: 'left',
    textDecoration: 'none',
    transition: StyleUtils.fastTransition,
    fontFamily: 'Helvetica Neue, Helvetica, Open Sans, sans-serif',
    fontWeight: 300,
    fontSize: 14,
    ':hover': {
      backgroundColor: StyleUtils.tmdBlue,
    },
  },
  applyButtonText: {
    fontWeight: 400,
    fontSize: 18,
    margin: 0,
    padding: 0,
  },
  sectionNavLink: {
    display: 'inline-block',
    color: 'black',
    paddingLeft: '2%',
    paddingRight: '2%',
    textDecoration: 'none',
    fontFamily: 'Helvetica Neue, Helvetica, Open Sans, sans-serif',
    fontWeight: 300,
    fontSize: 16,
  },
  sectionNavBar: {
    width: '100%',
    borderTop: "1px solid black",
    borderBottom: "1px solid black",
  },
});

export default PositionPage;



// WEBPACK FOOTER //
// ./src/components/PositionPage.jsx